import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciPage,
  type SolveConfig,
  SolveForCalc,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { solveNormality } from "../lib/normality";

const config: SolveConfig = {
  resultTestId: "norm-result",
  hintLeaveBlank: () => m.norm_hint_leave_blank(),
  hintInvalid: () => m.norm_hint_invalid(),
  resultPrefix: () => m.sci_result_solves(),
  fields: [
    {
      id: "normality",
      label: () => m.norm_field_normality(),
      kind: "plain",
      units: [{ value: "N", label: "N" }],
    },
    {
      id: "density",
      label: () => m.norm_field_density(),
      kind: "plain",
      placeholder: "1.18",
    },
    {
      id: "assay",
      label: () => m.norm_field_assay(),
      kind: "plain",
      placeholder: "37",
    },
    {
      id: "ew",
      label: () => m.norm_field_ew(),
      kind: "plain",
      placeholder: "36.46",
    },
  ],
  solve: (base) => {
    const blanks = ["normality", "density", "assay", "ew"].filter(
      (id) => base[id] === null,
    );
    if (blanks.length !== 1) return null;
    const value = solveNormality({
      normality: base.normality,
      density: base.density,
      assay: base.assay,
      ew: base.ew,
    });
    return value === null ? null : { id: blanks[0], value };
  },
};

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.norm_tool_name()}
        toolPath="/normality"
      />

      <header className="mt-6 mb-8">
        <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
          {m.norm_h1()}
        </h1>
        <p className="mt-3 leading-relaxed text-muted-foreground">
          {m.norm_intro()}
        </p>
      </header>

      <SolveForCalc config={config} />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.norm_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.norm_ex1(), m.norm_ex2(), m.norm_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.norm_faq_q1(), a: m.norm_faq_a1() },
          { q: m.norm_faq_q2(), a: m.norm_faq_a2() },
          { q: m.norm_faq_q3(), a: m.norm_faq_a3() },
          { q: m.norm_faq_q4(), a: m.norm_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
